"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _classList = babelHelpers.interopRequireDefault(require("class-list"));

var _decorators = require("decorators");

var _tabbedContent = require("tabbed-content");

var _ProfileImageContainer = babelHelpers.interopRequireDefault(require("components/ProfileImageContainer"));

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _temp;

var CommentForm = (_class = (_temp =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(CommentForm, _Component);

  function CommentForm() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, CommentForm);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(CommentForm)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "gotCommentField", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "submitComment", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "userProfile", _descriptor3, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "submitting", _descriptor4, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "acceptEmptyComment", _descriptor5, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "canSubmit", _descriptor6, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "placeholder", _descriptor7, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "commentFieldMinLines", _descriptor8, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "hidden", _descriptor9, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "submitButtonText", _descriptor10, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "showComment", _descriptor11, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "updateComment", _descriptor12, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "contentAfterField", _descriptor13, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "bareComment", _descriptor14, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "value", _descriptor15, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    _this.state = {
      comment: _this.value
    };
    _this.componentIsMounted = false;
    return _this;
  }

  babelHelpers.createClass(CommentForm, [{
    key: "commentUpdated",
    value: function commentUpdated(event) {
      var _this2 = this;

      this.setState({
        comment: event.target.value
      }, function () {
        if (_this2.bareComment) _this2.updateComment(_this2.state.comment);
      });
    }
  }, {
    key: "doSubmitComment",
    value: function doSubmitComment(event) {
      var _this3 = this;

      event.preventDefault();
      this.submitComment(this.state.comment).then(function (value) {
        if (_this3.componentIsMounted) {
          _this3.setState({
            comment: ""
          });

          if (_this3.bareComment) _this3.updateComment("");
        }
      }).catch(function () {});
    }
  }, {
    key: "isDisabled",
    value: function isDisabled() {
      if (!this.canSubmit) return true;

      if (this.showComment) {
        if (!this.acceptEmptyComment) {
          return this.state.comment == '';
        }
      }

      return false;
    }
  }, {
    key: "gotFakeElement",
    value: function gotFakeElement(node) {
      this.fakeElement = node;
    }
  }, {
    key: "internalGotCommentField",
    value: function internalGotCommentField(node) {
      this.commentField = node;
      this.gotCommentField(node);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevState.comment != this.state.comment && this.fakeElement && this.commentField) {
        this.updateSize();
      } else if (prevProps.hidden != this.props.hidden && !this.props.hidden) {
        this.updateSize();
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateSize();
      this.componentIsMounted = true;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.componentIsMounted = false;
    }
  }, {
    key: "updateSize",
    value: function updateSize() {
      var _this4 = this;

      if (this.fakeElement && this.commentField) {
        var v = this.state.comment || this.placeholder || "";
        var nl = this.fakeElement.childNodes;
        var cStyle = window.getComputedStyle(this.commentField);
        ['boxSizing', 'paddingTop', 'paddingBottom', 'paddingLeft', 'paddingRight', 'borderTopWidth', 'borderLeftWidth', 'borderRightWidth', 'borderBottomWidth', 'whiteSpace', 'fontFamily', 'fontStyle', 'fontSize', 'fontWeight', 'lineHeight'].forEach(function (p) {
          return _this4.fakeElement.style[p] = cStyle[p];
        });
        this.fakeElement.style.position = 'fixed';
        this.fakeElement.style.right = '150%';
        v = v.split('\n');

        for (var i = 0; i < v.length; i++) {
          if (!nl[i]) this.fakeElement.appendChild(document.createElement('div'));
          nl[i].textContent = v[i] || '\xa0';
        }

        while (nl.length > v.length) {
          this.fakeElement.removeChild(nl[nl.length - 1]);
        }

        var w,
            tgtH,
            rowCount = this.commentFieldMinLines;
        this.commentField.style.overflow = 'hidden';

        do {
          w = this.commentField.clientWidth;
          console.log(this.fakeElement.style.width = this.fakeElement.style.boxSizing == 'border-box' ? "".concat(w, "px") : "calc(".concat(w, "px - ").concat(cStyle.paddingLeft, " - ").concat(cStyle.paddingRight, " - ").concat(cStyle.borderLeftWidth, " - ").concat(cStyle.borderRightWidth, ")"));
          tgtH = window.getComputedStyle(this.fakeElement).height; // tgtH = this.fakeElement.offsetHeight;

          console.log(this.commentField.style.height = tgtH); // this.fakeElement.style.boxSizing == 'border-box' ? `${tgtH}px` : `calc(${tgtH}px - ${cStyle.paddingTop} - ${cStyle.paddingBottom} - ${cStyle.borderTopWidth} - ${cStyle.borderBottomWidth})`);
        } while (w != this.commentField.clientWidth);

        (0, _tabbedContent.fix)();
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.userProfile) return null;

      if (this.props.bareComment) {
        return _react.default.createElement("div", {
          className: "comment"
        }, _react.default.createElement("div", {
          className: "comment-field"
        }, this.props.children, this.showComment && _react.default.createElement("textarea", {
          ref: this.internalGotCommentField,
          className: "form-control",
          name: "comment",
          rows: "3",
          placeholder: this.placeholder,
          value: this.state.comment,
          onChange: this.commentUpdated,
          disabled: this.submitting
        }), this.showComment && _react.default.createElement("div", {
          className: _classList.default.join('fake-textarea', this.state.comment ? '' : 'fake-textarea-placeholder'),
          ref: this.gotFakeElement
        })));
      }

      return _react.default.createElement("form", {
        method: "post",
        onSubmit: this.doSubmitComment
      }, _react.default.createElement("div", {
        className: "photo"
      }, _react.default.createElement(_ProfileImageContainer.default, {
        className: "userProfilePhoto",
        noImageClassName: "initials default",
        image: this.userProfile.photo,
        name: this.userProfile.nickname || this.userProfile.fullName || ""
      })), _react.default.createElement("div", {
        className: "comment"
      }, _react.default.createElement("div", {
        className: "comment-field"
      }, !this.contentAfterField && this.props.children, this.showComment && _react.default.createElement("textarea", {
        ref: this.internalGotCommentField,
        className: "form-control",
        name: "comment",
        rows: "3",
        placeholder: this.placeholder,
        value: this.state.comment,
        onChange: this.commentUpdated,
        disabled: this.submitting
      }), this.showComment && _react.default.createElement("div", {
        className: _classList.default.join('fake-textarea', this.state.comment ? '' : 'fake-textarea-placeholder'),
        ref: this.gotFakeElement
      }), this.contentAfterField && this.props.children), _react.default.createElement("button", {
        className: "btn",
        type: "submit",
        disabled: this.isDisabled() || this.submitting
      }, this.submitButtonText), this.props.cancel));
    }
  }]);
  return CommentForm;
}(_react.Component), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "gotCommentField", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return function () {};
  }
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "submitComment", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return function () {};
  }
}), _descriptor3 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "userProfile", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "submitting", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor5 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "acceptEmptyComment", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor6 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "canSubmit", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor7 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "placeholder", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 'Enter your comment or question...';
  }
}), _descriptor8 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "commentFieldMinLines", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 3;
  }
}), _descriptor9 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "hidden", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor10 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "submitButtonText", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 'Post';
  }
}), _descriptor11 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "showComment", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor12 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "updateComment", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return function () {};
  }
}), _descriptor13 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "contentAfterField", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor14 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "bareComment", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor15 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "value", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), babelHelpers.applyDecoratedDescriptor(_class.prototype, "commentUpdated", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "commentUpdated"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "doSubmitComment", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "doSubmitComment"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "gotFakeElement", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "gotFakeElement"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "internalGotCommentField", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "internalGotCommentField"), _class.prototype)), _class);
exports.default = CommentForm;